require("dotenv").config();

export const apiBaseUrl = process.env.REACT_APP_EXPRESSJS_URL;
